/**
 * @description:
 * @author: Rian
 * @date: 2022-05-10 11:27:22
 **/

const baseSize = 16;

const _isMobile = function() {
	let flag = window.navigator.userAgent.match(
		/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
	)
	return flag;
}

function setRem() {
	const ww = document.documentElement.clientWidth;
	let w = baseSize;
	if (!_isMobile()) {
		// 当前页面宽度相对于 1920宽的缩放比例，可根据自己需要修改。 
		const scale = document.documentElement.clientWidth / 1920;
		w = baseSize * Math.min(scale, 2);
		// 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2）
	} else {
		const scale = document.documentElement.clientWidth / 420;
		w = baseSize * Math.min(scale, 2);
	}
	document.documentElement.style.fontSize = w + 'px';
	// document.documentElement.style.widows = baseSize * Math.min(scale, 2)+ 'px';
}
setRem()
window.onresize = function() {
	setRem()
}



// WEBPACK FOOTER //
// ./src/config/rem.js